module.exports = __webpack_public_path__ + "static/mpost25.4ff50a36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost25.jpg
// module id = 996
// module chunks = 35783957827783